import {BOOKING_RESET, FETCH_CART, FETCH_ORDER_DETAILS} from "./actions";
import {Cart} from "./types";

export const initialCartState: Cart = null;

export function cartReducer(
    state = initialCartState,
    action: any
): Cart {
    switch (action.type) {
        case FETCH_CART: {
            const totalQuantity = action.payload.items.filter(item => !item.isDeposit && !item.isMileageOption).map(item => item.qty).reduce((previousValue, currentValue) => {
                return previousValue + currentValue;
            }, 0)

            const groupedQuantity = action.payload.items.filter(item => !item.isMileageOption && !item.isDeposit && item.parentIds.length === 0).map(item => item.qty).reduce((previousValue, currentValue) => {
                return previousValue + currentValue;
            }, 0)

            const totalQuantityWithShipping = action.payload.shipping ? totalQuantity + 1 : totalQuantity;
            const groupedQuantityWithShipping = action.payload.shipping ? groupedQuantity + 1 : groupedQuantity;

            return {
                ...action.payload,
                totalQuantity: totalQuantity,
                totalQuantityWithShipping: totalQuantityWithShipping,
                groupedQuantityWithShipping: groupedQuantityWithShipping,
            };
        }
        case FETCH_ORDER_DETAILS: {
            if (action.payload.isExpired) {
                return initialCartState;
            }

            return state;
        }
        case BOOKING_RESET: {
            return initialCartState;
        }
        default:
            return state
    }
}
